const selectedTasks = (context) => context.selectedTasks;

const name = (context) => context.selectedTasks;

const perPage = (context) => context.perPage;

const labelIds = (context) => context.labelIds;

const activeCallbacks = (context) => context.activeCallbacks;
export default {
  name,
  perPage,
  selectedTasks,
  labelIds,
  activeCallbacks,
};
